import * as React from 'react';
import { useSelector } from 'react-redux';

import { MortgageWidgetPromoDiscount } from '../../components/MortgageWidgetPromoDiscount/MortgageWidgetPromoDiscount';
import { MortgageWidget } from '../../components/MortgageWidgetRedesign';
import { isOfferInGageSelector, mortgageSelector, offerSelector, selectOfferPriceRub } from '../../selectors';
import { selectMortgagePromoDiscountCampaignActive } from '../../selectors/abExperiments/selectMortgagePromoDiscountCampaignActive';
import { getOfferType, isNewbuilding } from '../../utils/offer_type';
import { useApplicationContext } from '../ApplicationContext';
import { useMortgageRate } from '../mortgage/hooks/useMortgageRate';

export const MortgageWidgetContainer: React.VFC = () => {
  const { config } = useApplicationContext();
  const offer = useSelector(offerSelector);
  const price = useSelector(selectOfferPriceRub);
  const isInGage = useSelector(isOfferInGageSelector);
  const { mortgageWidgetMarkup } = useSelector(mortgageSelector);
  const rate = useMortgageRate();
  const promoDiscountEnabled = useSelector(selectMortgagePromoDiscountCampaignActive);

  const isEnabled = config.get<boolean>('mortgage.isWidgetEnabled') || false;

  if (!isEnabled || isInGage) {
    return null;
  }

  if (promoDiscountEnabled && !isNewbuilding(getOfferType(offer))) {
    return <MortgageWidgetPromoDiscount />;
  }

  return <MortgageWidget mortgageWidgetMarkup={mortgageWidgetMarkup} price={price} rate={rate} />;
};
